<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="start" v-if="!esModal">
        <ion-button @click="openEnd">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Cliente {{cliente.nombre||'nuevo'}}</ion-title>
      <ion-buttons slot="end" v-if="esModal">
        <ion-button @click="cerrarModal">
          <i class="icon ion-ios-close-circle-outline"></i>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content :class="!esModal?'ion-padding':''">
    <ion-item v-if="cliente._id">
      <ion-segment :value="modo" v-on:ionChange="setModo($event.detail.value)">
        <ion-segment-button :value="'general'">General</ion-segment-button>
        <ion-segment-button :value="'equipos'" v-if="cliente._id">Equipos {{equipos.length}}</ion-segment-button>
        <ion-segment-button :value="'proyectos'" v-if="cliente._id">Proyectos de seguimiento</ion-segment-button>
      </ion-segment>
    </ion-item>
    <ion-list v-if="modo=='general'">
      <ion-item v-for="c in campos" :key="c.label">
        <ion-label>{{c.label}}</ion-label>
        <ion-input v-if="['checkbox','select'].indexOf(c.type)==-1" :type="c.type" class="ion-text-right" color="primary" :value="cliente[c.name]" v-on:ionChange="set(c.name,$event.detail.value)"></ion-input>
        <ion-select v-if="c.type=='select'" :value="cliente[c.name]" v-on:ionChange="set(c.name,$event.detail.value)">
          <ion-select-option v-for="o in c.options" :key="o._id" :value="o._id">{{o.alias||o.nombre}}</ion-select-option>
        </ion-select>
        <ion-toggle slot="end" v-if="c.type=='checkbox'" :checked="cliente[c.name]==true" v-on:ionChange="set(c.name,$event.detail.checked==true)"></ion-toggle>
      </ion-item>
    </ion-list>
    <ion-list v-if="modo=='equipos'">
      <ion-item v-for="e in equipos" :key="e._id" @click="$router.push('/catalogos/equipos/'+e._id+'/modo/historial')">
        <ion-thumbnail slot="start" v-if="e.imagenes && e.imagenes[0]">
          <ion-img :src="cdn+e.imagenes[0].imagen" />
        </ion-thumbnail>
        <ion-label text-wrap>
          <h2>{{e.nombre}} {{e.marca}} {{e.modelo}}</h2>
          <p>{{e.sn}}</p>
          <p>{{e.tipo}}, en {{e.area}} {{e.subarea}}</p>
        </ion-label>
        <ion-note slot="end">Ver historial</ion-note>
      </ion-item>
    </ion-list>
    <div v-if="modo=='proyectos'">
      <ion-list>
        <ion-item>
          <ion-label>
            <h2>Proyectos</h2>
          </ion-label>
          <ion-button slot="end" fill="clear" @click="agregarSlotProyecto">
            <i class="icon ion-ios-add-circle"></i>
          </ion-button>
        </ion-item>
        <ion-item v-for="(p,indice) in proyectos" :key="indice">
          <ion-label position="floating">Proyecto {{indice+1}}</ion-label>
          <ion-input :value="p.nombre" v-on:ionChange="p.nombre=$event.detail.value"></ion-input>
        </ion-item>
        <pre v-if="!modoProduccion">{{proyectos}}</pre>
      </ion-list>
    </div>
    <ion-fab horizontal="end" vertical="bottom" slot="fixed">
      <ion-fab-button color="primary" @click="guardar" :disabled="!(yo.rol=='administrador' || yo._id==cliente.idAutor)">
        <i class="icon icon-lg ion-ios-save"></i>
      </ion-fab-button>
    </ion-fab>
  </ion-content>
</ion-app>
</template>
<script>
import Api from '@/components/Api/Api'
import sha1 from 'sha1'
export default {
  name: 'CatalogoCliente',
  props: {
    id: {
      type: String,
      default: ''
    },
    esModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      yo: Api.fetchLocal('cmms.yo') || {},
      modo: 'general',
      modoProduccion: Api.modoProduccion,
      cdn: Api.cdn + '/',
      cliente: {
        idAutor: (Api.fetchLocal('cmms.yo') || {})._id,
        fecha: new Date().getTime()
      },
      proyectos: [],
      equipos: [],
      campos: [{
        /*label: 'Alias',
        type: 'text',
        name: 'alias'
      }, {//*/
        label: 'Nombre',
        type: 'text',
        name: 'nombre'
      }, {
        label: 'RFC',
        type: 'text',
        name: 'rfc'
      }, {
        label: 'Email',
        type: 'email',
        name: 'email'
      }, {
        label: 'Dirección',
        type: 'text',
        name: 'direccion'
      }, {
        label: 'Teléfono',
        type: 'tel',
        name: 'telefonos'
      }, {
        label: 'Representante',
        type: 'text',
        name: 'representante'
      }, {
        label: 'Branding predeterminado',
        type: 'select',
        name: 'idBranding',
        options: []
      }]
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    setModo(val) {
      this.modo = val
      if (this.modo == 'equipos')
        this.obtenerEquipos()
    },
    async obtenerEquipos() {
      this.equipos = (await Api.find('equipo', ['idCliente,eq,' + this.cliente._id]))
        .sort((a, b) => a.sn > b.sn ? 1 : -1)
    },
    set(campo, valor) {
      this.cliente[campo] = valor
      console.log("set", campo, valor)
    },
    async guardar() {
      let cl = await Api.save('cliente', this.cliente)
      toast("Guardado")
      if (this.proyectos.length > 0) {
        let proyectosExistentes = await Api.find('proyectoorden', ['idCliente,eq,' + this.id])
        for (let pr of proyectosExistentes)
          await Api.delete('proyectoorden', pr._id)
        await Api.wait(2000)
        this.proyectos = this.proyectos
          .filter(p => p.nombre != '')
          .map(p => {
            p._id = sha1(cl._id + p.nombre).substring(0, 24)
            return p
          })
        for (let pr of this.proyectos)
          await Api.save('proyectoorden', pr)
      }
      if (!this.esModal) {
        await Api.wait(500)
        this.$router.push('/catalogos/clientes')
      } else {
        Api.$emit('nuevoClienteCreado', cl._id)
      }
    },
    agregarSlotProyecto() {
      this.proyectos.push({
        activo: true,
        nombre: '',
        idCliente: this.cliente._id
      })
    },
    cerrarModal() {
      Api.$emit('cerrarModal', true)
    }
  },
  async mounted() {
    for (let i in this.campos)
      if (this.campos[i].name == 'idBranding') {
        this.campos[i].options = await Api.get('branding')
      }
    if (this.id && this.id.length > 1) {
      this.cliente = await Api.get('cliente', this.id)
      this.proyectos = await Api.find('proyectoorden', ['idCliente,eq,' + this.id])
    }
  }
}
</script>
